import applePay from 'braintree-web/apple-pay'
import client from 'braintree-web/client'
import paypalCheckout from 'braintree-web/paypal-checkout'

import mockedClient from './mockedClient'

const integrationObject =
  typeof window !== 'undefined' && window.app.envName === 'test' ? mockedClient : { client, applePay, paypalCheckout }

export default integrationObject
